"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELLER_ARRANGES_FREIGHT_INCOTERMS = void 0;
exports.sellerArrangesFreight = sellerArrangesFreight;
// Incoterms where the seller arranges + pays freight, so the buyer records none: CFR/CIF + the D-terms.
exports.SELLER_ARRANGES_FREIGHT_INCOTERMS = ['CFR', 'CIF', 'DAP', 'DPU', 'DDP'];
const SELLER_ARRANGES_SET = new Set(exports.SELLER_ARRANGES_FREIGHT_INCOTERMS);
function sellerArrangesFreight(incoterms) {
    return incoterms != null && SELLER_ARRANGES_SET.has(incoterms);
}
//# sourceMappingURL=freight-incoterms.js.map